const WinePDP = {
	init: function() {
		// console.log('WinePDP specific code');


	    $('#tab-tn').on('click', function() {
	      $('.product-tab').removeClass('active');
	      $(this).addClass('active');
	      $('.entry-tab-content').removeClass('active');
	      $('.entry-tasting-notes').addClass('active');
	    });
	    $('#tab-s').on('click', function() {
	      $('.product-tab').removeClass('active');
	      $(this).addClass('active');
	      $('.entry-tab-content').removeClass('active');
	      $('.entry-specs').addClass('active');
	    });
	    $('#tab-vo').on('click', function() {
	      $('.product-tab').removeClass('active');
	      $(this).addClass('active');
	      $('.entry-tab-content').removeClass('active');
	      $('.entry-vintage-outlook').addClass('active');
	    });

	    $('.entry-tab-content.gift-description').each(function(){
	    	let target = $(this)
	    	let visHeight = target.height()
	    	let fullHeight = target.find('.wrap').height();
	    	
	    	if(fullHeight > visHeight) {
	    		target.parent().addClass('abridged');
	    	}

	    })

	    $('.readmore').on('click', function(){
	    	let cont = $('.entry-content');
	    	cont.toggleClass('show-full');
	    	// console.log(cont.length);
	    })
	}
}

export default WinePDP